(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle', function (event) {
    var openedItem = event.target;

    if (
      !openedItem.matches('.wb-product-faqs__item') ||
      !openedItem.open
    ) {
      return;
    }

    var section = openedItem.closest('[data-wb-product-faqs]');

    if (!section) {
      return;
    }

    section
      .querySelectorAll('.wb-product-faqs__item[open]')
      .forEach(function (item) {
        if (item !== openedItem) {
          item.open = false;
        }
      });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-collection-toolbar"] && !Shopify.designMode) return;
  try {
    
  class WbCollectionToolbar extends HTMLElement {
    connectedCallback() {
      this.setupSort();
      this.setupStuckState();
      this.setupFilterButton();
      this.setupLoadingState();
    }

    // Auto-submit on change so shoppers don't hunt for a "Go" button.
    setupSort() {
      const form = this.querySelector('[data-sort-form]');
      const select = form?.querySelector('select');
      if (!form || !select) return;

      select.addEventListener('change', () => {
        this.classList.add('wb-cbar--loading');
        form.submit();
      });
    }

    // Adds a shadow only once the bar has actually stuck, so it sits flat
    // in the page flow until it starts overlapping content.
    setupStuckState() {
      if (!this.classList.contains('wb-cbar--sticky')) return;
      if (!('IntersectionObserver' in window)) return;

      const sentinel = document.createElement('div');
      sentinel.style.cssText = 'position:absolute;height:1px;width:1px;';
      this.parentNode?.insertBefore(sentinel, this);

      new IntersectionObserver(
        ([entry]) => this.classList.toggle('wb-cbar--stuck', !entry.isIntersecting),
        { rootMargin: '-1px 0px 0px 0px', threshold: 0 }
      ).observe(sentinel);
    }

    // Opens whichever filter drawer the theme already provides, rather than
    // shipping a competing one. Falls back to scrolling to the filter form.
    setupFilterButton() {
      const button = this.querySelector('[data-open-filters]');
      if (!button) return;

      button.addEventListener('click', () => {
        const candidates = [
          '[data-filters-drawer] button',
          'facets-drawer button',
          '.facets__disclosure-vertical summary',
          '#FacetsWrapperDesktop',
          '.mobile-facets__open',
        ];

        for (const selector of candidates) {
          const target = document.querySelector(selector);
          if (target) {
            target.click?.();
            target.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
            return;
          }
        }

        document
          .querySelector('#ProductGridContainer, .collection, main')
          ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // Any filter/chip click triggers a full page load — show progress so the
    // bar doesn't feel unresponsive on slow connections.
    setupLoadingState() {
      this.addEventListener('click', (event) => {
        const link = event.target.closest('a');
        if (!link || link.target === '_blank' || event.metaKey || event.ctrlKey) return;
        this.classList.add('wb-cbar--loading');
      });

      // Clear the state if the shopper comes back via the bfcache.
      window.addEventListener('pageshow', () => this.classList.remove('wb-cbar--loading'));
    }
  }

  if (!customElements.get('wb-collection-toolbar')) {
    customElements.define('wb-collection-toolbar', WbCollectionToolbar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-comparison-table"] && !Shopify.designMode) return;
  try {
    
  // Stamp each cell with its column header so the mobile card layout can
  // label it. Doing this in JS keeps the Liquid free of repeated labels.
  document.querySelectorAll('.wb-cmp__table').forEach((table) => {
    const headers = Array.from(table.querySelectorAll('thead th')).map((th) => th.textContent.trim());
    table.querySelectorAll('tbody tr').forEach((row) => {
      row.querySelectorAll('td').forEach((cell, index) => {
        // +1 because the row's <th> occupies the first column.
        cell.setAttribute('data-label', headers[index + 1] || '');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-footer"] && !Shopify.designMode) return;
  try {
    
  // Footer columns render open so desktop always shows the links even with
  // JavaScript disabled. Below 750px they collapse into accordions.
  (function () {
    var query = window.matchMedia('(max-width: 749px)');

    function sync() {
      document.querySelectorAll('.wb-ft__col').forEach(function (panel, index) {
        if (query.matches) {
          panel.open = false;
        } else {
          panel.open = true;
        }
      });
    }

    sync();
    query.addEventListener ? query.addEventListener('change', sync) : query.addListener(sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-seo-keywords"] && !Shopify.designMode) return;
  try {
    
// "Read more" toggle for the collapsible SEO paragraph. Progressive: with
  // JS off the text is clamped but still fully present in the DOM.
  document.querySelectorAll('[data-seo-more]').forEach((button) => {
    const body = button.parentElement?.querySelector('.wb-seo__body--collapsible');
    if (!body) return;

    const label = button.querySelector('[data-seo-more-label]');
    const moreText = label?.textContent?.trim() || 'Read more';
    const lessText = button.dataset.lessLabel || 'Read less';

    button.addEventListener('click', () => {
      const expanded = body.dataset.expanded === 'true';
      body.dataset.expanded = String(!expanded);
      button.setAttribute('aria-expanded', String(!expanded));
      if (label) label.textContent = expanded ? moreText : lessText;
    });
  });
// Keyword groups render open so they are always visible (and crawlable) on
  // desktop and without JavaScript. Below 600px they collapse to accordions.
  (function () {
    var query = window.matchMedia('(max-width: 599px)');

    function sync() {
      document.querySelectorAll('.wb-seo__group').forEach(function (panel) {
        panel.open = !query.matches;
      });
    }

    sync();
    query.addEventListener ? query.addEventListener('change', sync) : query.addListener(sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wildebeast-tannery-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.wb-tannery').forEach((section) => {
    const track = section.querySelector('.wb-tannery__track');
    const slides = Array.from(section.querySelectorAll('.wb-tannery__slide'));
    const position = section.querySelector('.wb-tannery__position span');
    const previous = section.querySelector('.wb-tannery__arrow--previous');
    const next = section.querySelector('.wb-tannery__arrow--next');

    const currentIndex = () => {
      const trackLeft = track.getBoundingClientRect().left;
      return slides.reduce((closest, slide, index) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        return distance < closest.distance ? { index, distance } : closest;
      }, { index: 0, distance: Infinity }).index;
    };

    const goTo = (index) => {
      const target = Math.max(0, Math.min(slides.length - 1, index));
      slides[target].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    previous.addEventListener('click', () => goTo(currentIndex() - 1));
    next.addEventListener('click', () => goTo(currentIndex() + 1));
    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(() => { position.textContent = currentIndex() + 1; });
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();
})();
